import { API_PREFIX } from '@sbg/shared/constants';

export const SITE_NAME = 'Shree Balaji Granites';
export const DEFAULT_SITE_URL = 'http://localhost:5173';

/**
 * Canonical origin for absolute URLs (canonical link, Open Graph). `VITE_SITE_URL` in production;
 * read lazily so tests can stub the environment.
 */
export function getSiteUrl(): string {
  const configured = import.meta.env.VITE_SITE_URL?.trim();
  return (configured ? configured : DEFAULT_SITE_URL).replace(/\/+$/, '');
}

/**
 * Turn a site path (`/shop`) or an absolute URL into an absolute URL on the canonical origin.
 *
 * Absolute URLs are used for the canonical link, structured data, share links and the WhatsApp
 * message. An address that is already absolute is returned as it is.
 */
export function absoluteUrl(pathOrUrl: string): string {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${getSiteUrl()}${path}`;
}

/** API base: `VITE_API_BASE` (absolute or same-origin path) or the shared default `/api/v1`. */
export function getApiBase(): string {
  const configured = import.meta.env.VITE_API_BASE?.trim();
  return (configured ? configured : API_PREFIX).replace(/\/+$/, '');
}
